import { useState } from "react";

import CreateAgentPolicy from "./components/CreateAgentPolicy";
import AgentPolicyContent from "./components/AgentPolicyContent";

import PlusIcon from "../../../../Components/Icon-SVG/PlusIcon";

import "./styles.scss";

const AgentPolicies = ({ selectedHost }) => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div className="agent-policies">
      <div className="agent-policies__header">
        <div>
          <h1>Policies</h1>
          <p>Create and manage policies. Use arrow buttons to reorder priority (top = highest).</p>
        </div>
        <button
          type="button"
          className="save-button primary-button"
          onClick={() => setShowPopup(true)}>
          <PlusIcon color="var(--dashboard-value-color)" width={16} height={16} /> Create Policy
        </button>
      </div>
      <AgentPolicyContent selectedHost={selectedHost} />
      {showPopup ? (
        <CreateAgentPolicy
          showPopup={showPopup}
          setShowPopup={setShowPopup}
          selectedHost={selectedHost}
        />
      ) : null}
    </div>
  );
};

export default AgentPolicies;
